import axios from "@/libs/api.request";

export const addPostPickup = data => {
  return axios.request({
    url: "/endpoint/addPickup",
    method: "post",
    data
  });
};
